import { forwardRef, useImperativeHandle, useRef } from 'react';

import {
  SharepointFileUrlInput,
  SharepointFileUrlInputRef,
} from '../shared/sharepoint-file-url-input';
import type { PolicyConfigProps, PolicyConfigRef } from './types';

export const PolicyConfigSharepoint = forwardRef<PolicyConfigRef, PolicyConfigProps>(
  ({ orgIntegrationId, isDisabled, onDirtyChange }, ref) => {
    const innerRef = useRef<SharepointFileUrlInputRef>(null);

    useImperativeHandle(ref, () => ({
      submit: async () => (await innerRef.current?.submit()) ?? null,
      reset: () => innerRef.current?.reset(),
    }));

    return (
      <SharepointFileUrlInput
        ref={innerRef}
        orgIntegrationId={orgIntegrationId}
        isDisabled={isDisabled}
        onDirtyChange={onDirtyChange}
      />
    );
  },
);
PolicyConfigSharepoint.displayName = 'PolicyConfigSharepoint';
